










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class IntegerComponent extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: any[];
  @Prop({ type: String }) placeholder!: string;


  localValue: any = null

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  updateValue(value: any) {
    value = parseInt(value.replace(',', '.'))
    this.onValueChange(value);

    this.$emit('input', value);
  }
}
